import AddedToCartModal from './AddedToCartModal';

export default AddedToCartModal;
